import React from 'react'

import SegmentControlBase from 'src/components/SegmentControl'

import { useSegmentControlContext } from '../..'

function SegmentControl() {
  const segmentControlContext = useSegmentControlContext()

  return (
    <SegmentControlBase
      defaultValue="sharing"
      onChange={({ target: { value } }) =>
        segmentControlContext.setCurrent(value)
      }
      segments={segmentControlContext.segments}
      value={segmentControlContext.current}
    />
  )
}

export default SegmentControl
